import {NgModule} from '@angular/core';

import {ApplicationDisclaimerDirective} from './application-disclaimer.directive';

@NgModule({
  declarations: [ApplicationDisclaimerDirective],
  exports: [ApplicationDisclaimerDirective],
})
export class ApplicationDisclaimerModule {}
